import RevealController from "@stimulus-components/reveal";

export default class CheckboxRevealController extends RevealController {
  static targets = ["item"];
  static values = { hiddenClass: String };

  connect(): void {
    super.connect();
    this.updateVisibility();
  }

  toggle(): void {
    this.updateVisibility();
  }

  private updateVisibility(): void {
    const checkbox = this.element.querySelector('input[type="checkbox"]') as HTMLInputElement;

    if (checkbox && checkbox.checked) {
      this.show();
    } else {
      this.hide();
    }
  }

  show(): void {
    this.itemTargets.forEach((element) => {
      element.classList.remove(this.hiddenClass);
    });
  }

  hide(): void {
    this.itemTargets.forEach((element) => {
      element.classList.add(this.hiddenClass);
    });
  }
}
